/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { Button, Drawer, Switch, Popconfirm, Modal, Select } from 'antd';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons'
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { StorageManager } from "datastake-daf/src/helpers/StorageManager";

import EventCreate from './create';
import { actions } from '../../../store/reducers/events';
import DynamicView from '../../DynamicViewNew/index';
import { displayMessage } from '../../../helpers/Messages';
import { canViewFeatureAction } from '../../../constants/roles';
import CanAccess from '../../../helpers/CanAccess';
import { getPopupContainer } from '../../../helpers/popUp';
import PageHeader from '../../Layout/PageHeader';
import { DrawerHeader, ModalHeader } from 'datastake-daf/dist/components';
import { CREATE_DRAWER_WIDTH } from '../../../helpers/form';

const Styles = styled.div`
	.ant-page-header {
		padding: 8px 8px 8px var(--size);
		border-bottom: 1px solid rgba(0, 0, 0, 0.1);
		.ant-page-header-back-button {
			color: var(--color-primary-70);
		}
		.ant-page-header-heading {
			justify-content: flex-start;
		}
		.ant-page-header-heading-left {
			margin-top: 0;
		}
		.ant-page-header-heading-title {
			line-height: 22px;
			margin-top: 4px;
		}
		.ant-page-header-heading-extra {
			display: flex;
			flex-direction: row;
			justify-content: space-between;
			align-items: center;
			flex-grow: 1;
			margin: 0 var(--size);
		}
		.ant-btn {
			display: flex;
			span[role="img"] {
				font-size: 18px;
			}
		}
	}
	.ant-descriptions {
		padding: var(--size)
	}
	.ant-descriptions:not(.project) {
		width: 100%;
		// width: calc(100% / 2);
		padding-bottom: 0;
		.ant-descriptions-title {
			font-size: 14px;
			font-weight: 500;
		}
		&:nth-of-type(1) {
			.ant-descriptions-title {
				opacity: 0;
			}
		}
	}
	.ant-descriptions-item {
		padding-bottom: 6px;
		.ant-descriptions-item-label {
			font-weight: 500
		}
	}
	.ant-col{
		padding: 0px 5px;
	}
	/* #tab-1
		margin-left: var(--size);
	} */
	.ant-tabs-nav .ant-tabs-nav-animated {
		margin-left: var(--size);
	}
	.view-toggle {
		width: 80px;
	}
`;

function EventInfo({
  module,
  view,
  events: { data: formData, loading },
  eventsDataGet,
  eventsFormReset,
  eventsRemove,
  authentication: { user },
}) {
  const { t } = useTranslation();
  const goTo = useNavigate();
  const { id: datastakeId } = useParams();
  const {
    form = {},
    data = {},
    config = {},
  } = formData[`${module}-${view}`] || {};

  const canEdit = canViewFeatureAction({ user, module, feature: 'event', action: 'edit' }) ||
    canViewFeatureAction({ user, module, feature: 'events', action: 'create' });

  const [editVisible, setEditVisible] = useState(false);
  const [isTabsView, setTabsView] = useState(StorageManager.get('datastake-view-mode') === 'section');
  const [activeFormIndex, setActiveFormIndex] = useState('');
  const [deletionVisible, setDeletionVisible] = useState(false);
  const [deletionReason, setDeletionReason] = useState(null);


  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (datastakeId) {
      setActiveFormIndex('');
      eventsFormReset({ module, view })
      eventsDataGet({ namespace: 'Events', module, view, datastakeId });
    }
  }, [datastakeId, user.language])

  return <CanAccess form={form} data={data} content={(
    <Styles className="semibold form-input-output" style={{ height: '100%' }}>
      <PageHeader
        title={t("Event Details")}
        // onBack={() => goBack ? goBack() : goTo(`/app/${module}/events`)}
        onBack={() => goTo(`/app/${module}/events`)}
        extra={[
          <div
            key="0"
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'center',
              alignItems: 'center'
            }}>
            {canEdit ? (<Button
              type="link"
              key="1"
              icon={<EditOutlined />}
              onClick={() => setEditVisible(true)}>
              {t("Edit")}
            </Button>) : null}
            {canEdit ? <Popconfirm
              title={t('deleteEvent')}
              okText={t('Yes')}
              cancelText={t('No')}
              onConfirm={() => setDeletionVisible(true)}>
              <Button
                icon={<DeleteOutlined />}
                type="link"
                style={{ marginLeft: '12px', color: 'red' }}
                size="small">
                {t("Delete")}
              </Button>
            </Popconfirm> : null}
          </div>,
          <div
            key="2"
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'center',
              alignItems: 'center'
            }}>
            <p style={{ margin: '0 12px 0 0' }}><strong>{t("View")}:</strong></p>
            <Switch
              checkedChildren={t("Sections")}
              unCheckedChildren={t("Full")}
              checked={isTabsView}
              onChange={(checked) => {
                if (checked) {
                  StorageManager.set('datastake-view-mode', 'section');
                } else {
                  StorageManager.set('datastake-view-mode', 'full');
                }
                setTabsView(checked)
              }}
              className="view-toggle"
            />
          </div>
        ]} />
      <DynamicView
        form={form}
        data={data}
        options={config.options}
        setEditVisible={canEdit ? (ind) => {
          setActiveFormIndex(ind);
          setEditVisible(true);
        } : null}
        onTabChange={(ind) => setActiveFormIndex(ind)}
        tabs={isTabsView}
      />
      <Drawer
        destroyOnClose={true}
        title={<DrawerHeader title={t("Edit event")} />}
        open={editVisible}
        maskClosable={false}
        onClose={() => {
          setEditVisible(false)
          eventsDataGet({ namespace: 'Events', module, view, datastakeId });
        }}
        width={CREATE_DRAWER_WIDTH}
        key="event"
        bodyStyle={{ padding: 0 }}
        onTabChange={(ind) => setActiveFormIndex(ind)}>
        <EventCreate
          namespace="Events"
          module={module}
          view={view}
          edit={true}
          form={form}
          formValue={data}
          onSubmitted={(type, m) => displayMessage(type, m)}
          onCancel={() => setEditVisible(false)}
          activeFormIndex={activeFormIndex}
        />
      </Drawer>
      <Modal
        title={(
          <ModalHeader
            title={t("Delete subject")}
          />
        )}
        cancelText={t("Cancel")}
        open={deletionVisible}
        onCancel={() => setDeletionVisible(false)}
        onOk={() => {
          eventsRemove({ id: data.id, data: { reason: deletionReason } }, (type, m) => {
            displayMessage(type, m);
            setDeletionVisible(false);
            setDeletionReason(null);
            goTo(`/app/${module}/events`);
          });
        }}
      >
        <Select
          {...getPopupContainer()}
          onChange={ev => setDeletionReason(ev)}
          placeholder={t('Please indicate the reason for deleting this subject')}
          style={{ width: '100%' }}
        >
          <Select.Option value="Duplicate">{t('Duplicate. This subject is already identified')}</Select.Option>
          <Select.Option value="Error">{t('Issue with core data')}</Select.Option>
          <Select.Option value="Non-Existent">{t('Subject does not exist and was created by mistake')}</Select.Option>
          <Select.Option value="Other">{t('Other reason')}</Select.Option>
        </Select>
      </Modal>
    </Styles>
  )} />;
}


const mstp = ({ events, authentication }) => ({ events, authentication });

export default connect(mstp, actions)(EventInfo);
